<script setup lang="ts">
import type {
  NovaBoxKpopFestivalEmits,
  NovaBoxKpopFestivalProps,
} from './NovaBoxKpopFestivalTerms.types'

const emit = defineEmits<NovaBoxKpopFestivalEmits>()
const props = defineProps<NovaBoxKpopFestivalProps>()
const { modelValue, terms } = toRefs(props)
const { show: modalShow } = useModal()
const { t } = useI18n()

const isAgreeAll = computed(
  () => terms.value?.length === modelValue.value.length
)
// 전체 동의 & 해제
const handleOnAllAgree = () => {
  const updateAgreeIds = isAgreeAll.value
    ? []
    : terms.value?.map((item) => item.fstvlApprtcStplatSn)
  emit('update:modelValue', updateAgreeIds)
}

// 일부 동의 & 해제
const handleOnAgree = (id: number) => {
  const updateAgreeIds = [...modelValue.value]
  const agreeIdx = updateAgreeIds.findIndex((item) => item === id)
  agreeIdx === -1 ? updateAgreeIds.push(id) : updateAgreeIds.splice(agreeIdx, 1)
  emit('update:modelValue', updateAgreeIds)
}

const openTermsModal = (id: number) => {
  modalShow(
    modalsName.MODAL_TERM_OF_SUPER_MOON,
    {
      fstvlApprtcStplatSn: id,
    },
    '',
    false
  )
}
</script>

<template>
  <NovaBoxPremiumSection class="rent-terms">
    <template #default>
      <div class="contents">
        <div class="box">
          <div class="lists-options">
            <div class="item">
              <NovaCheckbox
                :label="t('applyKpopCoverDance.terms.agreeAll')"
                :theme="'circle-md'"
                :is-check="isAgreeAll"
                @click="handleOnAllAgree"
              />
            </div>
            <div
              v-for="term in terms"
              :key="term.fstvlApprtcStplatSn"
              class="item"
            >
              <NovaCheckbox
                :label="term.stplatNm"
                :is-check="modelValue.includes(term.fstvlApprtcStplatSn)"
                :theme="'circle-md'"
                :font-size="'14px'"
                :font-weight="'100'"
                @click="() => handleOnAgree(term.fstvlApprtcStplatSn)"
              />
              <NovaButtonText
                :label="t('applyKpopCoverDance.terms.view')"
                :icon="{ type: 'outline', name: 'chev-thin-right' }"
                :icon-position="`right`"
                :theme="'transparent'"
                :size="32"
                class="btn-show-detail"
                @click="openTermsModal(term.fstvlApprtcStplatSn)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </NovaBoxPremiumSection>
</template>

<style lang="scss" scoped>
.rent-terms {
  padding: 0;
  margin-bottom: 60px;
}

.contents {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0;

  .box {
    width: 100%;
    padding: 0;

    .lists-options {
      display: flex;
      flex-direction: column;
      row-gap: 20px;

      @include mobile {
        row-gap: 12px;
      }

      .item {
        display: flex;
        justify-content: space-between;

        .btn-show-detail {
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
